import React, { CSSProperties } from "react";
import styled from "styled-components";

interface FiltersCounterProps {
  numActiveFilters: number;
  isIconButton?: boolean;
  style?: CSSProperties;
}

const FiltersCounter = ({
  numActiveFilters,
  isIconButton,
  style,
}: FiltersCounterProps) => {
  return (
    <>
      {numActiveFilters > 0 && (
        <ActiveFiltersCounter $isIconButton={isIconButton} style={style}>
          {numActiveFilters > 9 ? "*" : numActiveFilters}
        </ActiveFiltersCounter>
      )}
    </>
  );
};

export default FiltersCounter;

const ActiveFiltersCounter = styled.div<{ $isIconButton?: boolean }>`
  position: absolute;
  z-index: 2;
  background: ${(p) => p.theme.colors.primaryBlue};
  color: ${(p) => p.theme.colors.buttonText};
  top: ${(p) => (p.$isIconButton ? 0 : -3)}px;
  right: ${(p) => (p.$isIconButton ? -2 : -4)}px;
  width: ${(p) => (p.$isIconButton ? 12 : 14)}px;
  height: ${(p) => (p.$isIconButton ? 12 : 14)}px;
  font-size: ${(p) => (p.$isIconButton ? 9 : 12)}px;
  padding-left: ${(p) => (p.$isIconButton ? 0 : 1)}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;
